import { useLingui } from '@lingui/react/macro';
import { createFileRoute } from '@tanstack/react-router';

import { FormPage } from '@/components/page/FormPage';
import { PlanManagementView } from '@/features/organizations/plan-management/PlanManagementView';
import { partnerOrSuperAdminGuard } from '@/lib/routerUtils';
import { trpc } from '@/services/trpc';

export const Route = createFileRoute(
  '/_baseLayout/partner-billing/$organizationId',
)({
  component: PartnerBillingPage,
  // Page access: SuperAdmin + partner-capable admins. The specific client-org
  // scope is enforced by the billing procedures (assertCanManageClientOrganization).
  beforeLoad: async () => partnerOrSuperAdminGuard(),
  loader: async ({ context: { trpcUtils }, params: { organizationId } }) =>
    trpcUtils.organizations.findOne.ensureData({ id: organizationId }),
});

export function PartnerBillingPage() {
  const { organizationId } = Route.useParams();
  const { t } = useLingui();

  const [organizationData] = trpc.organizations.findOne.useSuspenseQuery({
    id: organizationId,
  });

  return (
    <FormPage
      title={`${t`Billing`} — ${organizationData.name}`}
      breadcrumbs={[
        { label: t`Organizations`, to: '/organizations' },
        {
          label: organizationData.name,
          to: '/organizations/$organizationId/edit',
          params: { organizationId },
        },
        {
          label: t`Billing`,
          to: '/partner-billing/$organizationId',
          params: { organizationId },
        },
      ]}
    >
      <PlanManagementView
        organizationId={organizationId}
        capabilities={{
          canLinkStripe: false,
          canManageInvoices: false,
          canForceCancel: false,
        }}
      />
    </FormPage>
  );
}
